import { DobAssetsProvider } from '@dedalusdiit/dob-components';
import { AuthenticationContextProvider } from './AuthenticationContext';
import { EventContextProvider } from './EventContext';
import { ThemeContextProvider } from './ThemeContext';

const AppContextProvider = (props: React.PropsWithChildren): React.ReactElement => {
    const { children } = props;

    return (
        <ThemeContextProvider>
            <DobAssetsProvider path="/assets">
                <EventContextProvider>
                    <AuthenticationContextProvider>
                        {children}
                    </AuthenticationContextProvider>
                </EventContextProvider>
            </DobAssetsProvider>
        </ThemeContextProvider>
    );
};

export default AppContextProvider;
